import React, { useEffect, useState } from "react";
import { useTheme } from "../context/useThemeContext";
import { HorizontalResizableLayout } from "../layouts";
import useMainStore from "../stores/mainStore";
import ToggleIconButton from "../components/buttons/toggleIconButton";
import { HiMenu } from "react-icons/hi";
import { hexToRGBA } from "../utility/hexToRGB";
import { saveMainStore } from "../utility/cache/manageMainStore";
import useIsLeftSidebarOverlay from "../hooks/useIsLeftSidebarOverlay";
import useAccountManagementStore from "../stores/accountManagementStore";

// Using a wrapper to prevent rerenders when the left sidebar is collapsed
function HorizontalResizeWrapper(props: {
    leftContent: React.ReactNode;
    rightContent: React.ReactNode;
    leftSidebarIsOverlay?: boolean;
}) {
    const { theme } = useTheme();

    const leftSidebarCollapsed = useMainStore(
        (state) => state.data.leftSidebarCollapsed
    );

    const leftSidebarIsOverlay = useIsLeftSidebarOverlay();

    return (
        <>
            {/* This is positioned absolutely, so it isn't hidden when left sidebar collapses */}
            <div
                className="flex items-center "
                style={{
                    backgroundColor: theme.headerColor,
                    position: "absolute",
                    left: "5px",
                    top: "5px",
                    zIndex: 999,
                }}
            >
                <ToggleIconButton
                    alt="Toggle Left Sidebar"
                    size={{ x: 32, y: 32 }}
                    iconSize={24}
                    isActive={false}
                    icon={<HiMenu />}
                    hoverBGInactive={hexToRGBA(theme.fontColor[100], 0.2)}
                    textColor={theme.fontColor[100]}
                    hoverTextColor={theme.fontColor[50]}
                    inactiveBGColor={theme.headerColor}
                    onClick={(e) => {
                        e.stopPropagation();
                        useMainStore
                            .getState()
                            .set.leftSidebarCollapsed((data) => !data);

                        const userID =
                            useAccountManagementStore.getState().userData?.id;

                        // Save Changes
                        saveMainStore(userID);
                    }}
                />
            </div>
            <HorizontalResizableLayout
                isCollapsed={leftSidebarCollapsed}
                leftContent={props.leftContent}
                rightContent={props.rightContent}
                leftSidebarIsOverlay={leftSidebarIsOverlay}
            />
        </>
    );
}

export default HorizontalResizeWrapper;
